<template>
  <div ref="pageView" class="page-view pd-lr-20 container-view">
    <section class="title-section fixed-view">
      <e6-title
        >通行证管理
        <template slot="operate">
          <el-button
            class="g-form-section-search operate__item"
            title="表格列设置"
            icon="e6-icon-field_line"
            @click="columSetVisible = !columSetVisible"
            plain
          ></el-button>
          <el-button
            v-if="operationSuper.编辑"
            class="g-form-section-search operate__item"
            title="编辑"
            icon="el-icon-plus"
            @click="$router.push('/basePassCheckEdit')"
            plain
          ></el-button>
          <el-button
            class="g-form-section-search operate__item"
            title="导出"
            v-if="operationSuper.导出"
            icon="e6-icon-export_line"
            @click="handleExportClick"
            plain
          ></el-button>
          <el-button
            class="g-form-section-search operate__item"
            :class="{ 'is-open': !isSearch }"
            icon="e6-icon-search_line"
            @click="handleIsSearch"
            plain
          ></el-button>
        </template>
      </e6-title>
    </section>
    <!-- title end -->
    <!-- 查询条件 -->
    <section class="g-form-section form-section fixed-view" :hidden="isSearch">
      <e6-form-extend
        class="form-extend e6-form--validate"
        :class="{ 'is-open': isSearch }"
        :formExtend="formExtend"
        @submitForm="handlesSubmitForm"
        @resetForm="handleResetForm"
      >
        <template slot-scope="slotForms">
          <el-form-item prop="forms.passcheckNo">
            <el-input
              v-model="slotForms.forms.passcheckNo"
              placeholder="通行证"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item>
            <e6Select
              :dataList="vehicleTreeList"
              :filterable="true"
              slotTemplate="tree"
              :issingleleaf="true"
              multiple
              ref="vehicleTreeSelect"
              :placeholder="'车辆'"
            ></e6Select>
          </el-form-item>
        </template>
        <template slot="submit">查询</template>
        <template slot="reset">重置</template>
      </e6-form-extend>
    </section>
    <!-- 查询条件 end -->

    <!-- 表格tab end -->
    <!-- 表格 -->
    <section class="table-section" :style="{ height: resizeViewHeight + 'px' }">
      <el-table
        v-loading="tableLoading"
        ref="multipleTable"
        border
        :data="tableData"
        height="100%"
      >
        <el-table-column
          v-for="(item, index) in localShowTableCols"
          :key="index"
          :show-overflow-tooltip="true"
          :prop="item.name"
          :label="item.title"
        ></el-table-column>
        <el-table-column align="center" label="操作" width="120">
          <template slot-scope="scope">
            <router-link
              v-if="operationSuper.编辑"
              :to="{
                path: '/basePassCheckEdit',
                query: { pageType: '2', id: scope.row.id }
              }"
              >编辑</router-link
            >&nbsp;
            <el-button
              v-if="operationSuper.删除"
              @click="deleteRow(scope)"
              type="text"
              size="small"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </section>
    <!-- 表格 end -->
    <!-- 翻页 -->
    <section class="pagination-section fixed-view">
      <e6-pagination
        :total="total"
        :pageSize.sync="pageSize"
        :currentPage.sync="curPage"
        @currentChange="handleCurrentChange"
        @sizeChange="handleSizeChange"
      ></e6-pagination>
    </section>
    <!-- 翻页 end -->
    <!-- 表格列设置 -->
    <e6-column-set
      @setColumnSubmit="handleSetColumnSubmit"
      @setColumnCancel="handleSetColumnCancel"
      :columSetVisible.sync="columSetVisible"
      :hideTableCols.sync="copyHideTableCols"
      :showTableCols.sync="copyShowTableCols"
    ></e6-column-set>
    <!-- 表格列设置 end -->
  </div>
</template>

<script>
import { FetchVehicleTree } from "@/api/base/vehicle";
import { DeleteDataById } from "@/api/base/passCheck";
import { mapActions } from "vuex";
import listInit from "@/mixins/listInit";
import { mergeFormExtend } from "_private/utils/merge";
import operationManage from "_private/mixins/operationManage";
export default {
  mixins: [listInit, operationManage],
  data() {
    return {
      vehicleTreeList: [],
      total: 0,
      curPage: 1,
      pageSize: 20,
      isSearch: false,
      formExtend: {
        forms: {
          passcheckNo: ""
        },
        extends: []
      },
      formsExtend: [],
      tableData: [],
      columSetVisible: false,
      showTableCols: [],
      hideTableCols: [],
      copyShowTableCols: [],
      copyHideTableCols: [],
      localShowTableCols: [],
      multipleSelection: [],
      messageBoxVisible: false,
      analysisError: false,
      aErrorDatas: [],
      idList: [],
      isFirstLoad: true,
      errMess: "",
      // 请求表格数据
      tableDataUrl: "/base/passCheck/findByPage",
      //导出URL
      exportUrl: "/base/passCheck/exportPassCheckInfo?"
    };
  },
  created() {
    this.setSearchFormIsOpenAct();
    //初始化区位树
    this.initVehicleTree();
    this.initPage();
  },
  mounted() {
    let idStr = this.$route.query.vehicleIds;
    if (idStr) {
      this.idList = idStr.split(",");
    }
  },
  methods: {
    ...mapActions(["setSearchFormIsOpenAct"]),
    handleExportClick() {
      let vehicleIdList;
      if (this.isFirstLoad) {
        vehicleIdList = this.idList;
        this.isFirstLoad = false;
      } else {
        vehicleIdList = this.getVehicleIdListParam();
      }
      let param = "";
      param += "&passcheckNo=" + this.formExtend.forms.passcheckNo;
      param += "&vehicleIdList=" + vehicleIdList;
      document.location.href = this.exportUrl + param;
    },
    //初始化区位树
    initVehicleTree() {
      FetchVehicleTree()
        .then(response => {
          if (response.result && Array.isArray(response.result)) {
            this.vehicleTreeList = response.result;
            this.$nextTick(() => {
              this.$refs.vehicleTreeSelect.setSelectList(this.idList);
            });
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    //获取选中区位id
    getVehicleIdListParam() {
      let selected = this.$refs.vehicleTreeSelect.getSelectValues();
      selected = selected.map(item => {
        return item.id;
      });
      return selected;
    },
    //重置
    handleResetForm() {
      this.$refs.vehicleTreeSelect.multipleRemoveAll();
    },
    // 删除行
    deleteRow({ row }) {
      this.$confirm("此操作将永久删除该记录, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(async () => {
          this.tableLoading = true;

          const { code, message } = await DeleteDataById({
            ids: row.id
          });

          this.tableLoading = false;

          if (code === 1) {
            this.successMessage("删除成功", () => {
              this.handleCurrentChange(1);
            });
          } else {
            this.errorMessage(message || "删除失败，请重试");
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    // 整合查询数据
    mergeObj() {
      let vehicleIdList;
      if (this.isFirstLoad) {
        vehicleIdList = this.idList;
        this.isFirstLoad = false;
      } else {
        vehicleIdList = this.getVehicleIdListParam();
      }
      return Object.assign({}, mergeFormExtend(this.formExtend), {
        vehicleIdList: vehicleIdList,
        curPage: this.curPage,
        pageSize: this.pageSize
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.page-view {
  height: 100%;
}
.title-section {
  padding: 15px 0 10px;
}
.table-section {
  height: 200px;
}
.pagination-section {
  padding: 10px 0;
}
.batch-delete {
  line-height: 100px;
  text-align: center;
  background-color: #fff;
}
</style>
